module.exports = __webpack_public_path__ + "static/media/wavm8s-007-otang.cd84279.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-007-otang.mp3
// module id = NqYg
// module chunks = 0